<app-loading-indicator></app-loading-indicator>
<app-backdrop #backdrop="appBackdrop"></app-backdrop>

<div class="container" fxLayout="column">
  <ng-container *ngIf="(toolbarPosition$ | async) === 'above-fixed'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>
  <mat-sidenav-container autosize fxFlex>
        <!-- SIDENAV -->
        <mat-sidenav (closedStart)="closeSidenav()"
                (openedStart)="openSidenav()"
                [mode]="(sidenavMode$ | async) ?? 'side'"
                [opened]="sidenavOpen$ | async"
                *ngIf="sideNavigation$ | async"
                class="app-collapsable-sidenav">
            <app-sidenav [collapsed]="(sidenavCollapsed$ | async) ?? false" [expanded]="(sidenavExpanded$ | async) ?? false"></app-sidenav>
        </mat-sidenav>
        <!-- END SIDENAV -->

        <mat-sidenav-content class="content-container" fxLayout="column">
          <ng-container *ngIf="(toolbarPosition$ | async) === 'fixed'">
            <ng-container *ngTemplateOutlet="toolbar"></ng-container>
          </ng-container>
    
          <!-- CONTENT -->
          <div [class.scroll-disabled]="scrollDisabled$ | async"
               cdkScrollable
               class="content"
               fxFlex="auto"
               fxLayout="column">
            <ng-container *ngIf="(toolbarPosition$ | async) === 'static'">
              <ng-container *ngTemplateOutlet="toolbar"></ng-container>
            </ng-container>
    
            <!-- <div class="content-inner" fxFlex="auto" *ngIf="(items.length != 0) && allowsidePage">
              <router-outlet></router-outlet>
            </div>

            <div class="content-inner" fxFlex="auto" *ngIf="(items.length == 0) && (!allowsidePage)">
               <app-loading-main-screem></app-loading-main-screem>
            </div> -->

            <div class="content-inner" fxFlex="auto" *ngIf="(itemsRevolution.length != 0) && allowsidePage">
              <router-outlet></router-outlet>
            </div>

            <div class="content-inner" fxFlex="auto" *ngIf="(itemsRevolution.length == 0) && (!allowsidePage)">
               <app-loading-main-screem></app-loading-main-screem>
            </div>
    
          </div>
          <!-- END CONTENT -->
    
        </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<ng-template #toolbar>
  <!-- TOOLBAR -->
  <app-toolbar (openQuickPanel)="openQuickPanel()"
                [hasNavigation]="(topNavigation$ | async) ?? false"
                (openSidenav)="openSidenav()"
                *ngIf="toolbarVisible$ | async"
                fxFlex="none"></app-toolbar>
  <!-- END TOOLBAR -->
</ng-template>